var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9674 7.63553L24.9679 7.66066C25.1107 15.1361 25.3059 25.3743 12.8404 29.6948C12.73 29.7332 12.6146 29.7523 12.4994 29.7523C12.3841 29.7523 12.2689 29.7332 12.1584 29.6948C-0.306134 25.3744 -0.110643 15.1366 0.0320991 7.66124L0.0320996 7.66122C0.0475124 6.85781 0.0619532 6.09869 0.0619532 5.36443C0.0619532 4.7893 0.528225 4.32303 1.10336 4.32303C5.55682 4.32303 8.94722 3.04307 11.7735 0.294874C12.1777 -0.0982218 12.8211 -0.0983607 13.2254 0.294874C16.052 3.04307 19.4429 4.32303 23.8967 4.32303C24.4719 4.32303 24.9381 4.7893 24.9381 5.36443C24.9381 6.09089 24.9523 6.84155 24.9674 7.63553ZM2.11463 7.70093C1.9712 15.2156 1.80957 23.7225 12.4995 27.6058C23.1903 23.7223 23.0288 15.2151 22.8855 7.70023C22.8769 7.24951 22.8686 6.81268 22.8627 6.38431C18.6913 6.20839 15.3552 4.94426 12.4995 2.45683C9.64413 4.94426 6.30858 6.20825 2.1374 6.38431C2.13157 6.81282 2.12324 7.24993 2.11463 7.70093ZM11.0593 16.2846L16.0857 11.2585C16.4924 10.8518 17.1518 10.8519 17.5583 11.2586C17.965 11.6652 17.965 12.3246 17.5582 12.7313L11.7956 18.4937C11.5923 18.697 11.3257 18.7987 11.0593 18.7987C10.7928 18.7987 10.5262 18.697 10.3229 18.4937L7.44171 15.6125C7.03501 15.2058 7.03501 14.5465 7.44171 14.1397C7.84828 13.7331 8.5077 13.7331 8.9144 14.1397L11.0593 16.2846Z",
    fill: "#00C8A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.a39edfc589571437a82848261b78b566.svg";
export { ForwardRef as ReactComponent };